export const SALES_POINTS = 'sales-points'
export const SALES_POINT_CREATE = 'sales-point-create'
export const SALES_POINT_EDIT = 'sales-point-edit'
export const SALES_POINT = 'sales-point'
export const SALES_POINT_LIST = 'sales-point-list'
export const SALES_POINT_MAP = 'sales-point-map'
